export var RecallSourceType;
(function (RecallSourceType) {
    RecallSourceType[RecallSourceType["RSPRecall"] = 10] = "RSPRecall";
})(RecallSourceType || (RecallSourceType = {}));
